import React, { useMemo } from "react";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import SecurePassLogTypeTag from "@/components/SecurePass/SecurePassLogTypeTag/SecurePassLogTypeTag";

const useSecurePassSummaryColumns = () =>
  useMemo(
    () => [
      {
        title: "Event Type",
        key: "type",
        dataIndex: "type",
        render: (text, record) => <SecurePassLogTypeTag logType={text} isSuccess={record.isSuccess} />,
      },
      {
        title: "Timestamp",
        key: "creationTime",
        dataIndex: "creationTime",
        render: text => <span className="span-click">{dateStringToStandardFormat(text, { showTime: true })}</span>,
      },
      {
        title: "Comments",
        key: "comments",
        dataIndex: "comments",
        render: text => <span className="span-click">{text === "-" || !text ? "N/A" : text}</span>,
      },
    ],
    [],
  );

export default useSecurePassSummaryColumns;
